import useStyles from './GoogleReviewsMinimal.styles';

const GOOGLE_REVIEWS_LOCKUP =
  '/cmsAssets/assets/img/google/google_reviews_minimal.svg';

export interface GoogleReviewsMinimalProps {
  /** Review copy shown next to the stars, e.g. "1,000+ five-star reviews". */
  reviewsText: string;
  isOnDark?: boolean;
  brandName?: string;
  align?: 'center' | 'start';
  className?: string;
}

export default function GoogleReviewsMinimal({
  reviewsText,
  isOnDark = false,
  brandName,
  align = 'center',
  className,
}: GoogleReviewsMinimalProps): React.JSX.Element | null {
  const { classes, cx } = useStyles({ isOnDark, align });

  const trimmedText = reviewsText.trim();
  if (!trimmedText) {
    return null;
  }

  const accessibleText = brandName
    ? `${brandName} has ${trimmedText} on Google.`
    : `${trimmedText} on Google.`;

  return (
    <div
      className={cx(classes.root, className)}
      data-testid='google-reviews-minimal'
      role='img'
      aria-label={accessibleText}
    >
      {/* biome-ignore lint/performance/noImgElement: static SVG lockup, no next/image needed */}
      <img
        src={GOOGLE_REVIEWS_LOCKUP}
        alt=''
        aria-hidden='true'
        className={classes.logo}
      />
      <p className={classes.text} aria-hidden='true'>
        {trimmedText}
      </p>
    </div>
  );
}
